import { showSupport } from 'utils/support';
import { alert } from '@ardoq/modal';
import { SecondaryButton } from '@ardoq/button';
import { Stack } from '@ardoq/layout';
import { Paragraph } from '@ardoq/typography';
import { t } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';

const ScenarioSlideErrorAlert = () => {
  // i18nLocale$.state OK here: imperative one-shot alert dialog opener.
  const i18nLocale = i18nLocale$.state;
  return alert({
    title: t(
      i18nLocale,
      'presentationAdmin:viewer.errors.scenarioSlide.title',
      'Error in slide data'
    ),
    text: (
      <Stack gap="medium" align="start">
        <Paragraph variant="text2">
          {t(
            i18nLocale,
            'presentationAdmin:viewer.errors.scenarioSlide.description',
            'This slide cannot be shown. There is an issue with the scenario in the slide data.'
          )}
        </Paragraph>
        <SecondaryButton onClick={() => showSupport()}>
          {t(
            i18nLocale,
            'presentationAdmin:viewer.errors.scenarioSlide.contactSupport',
            'Contact support'
          )}
        </SecondaryButton>
      </Stack>
    ),
  });
};

export { ScenarioSlideErrorAlert };
